import type { SVGAttributes } from 'react';

export function SpanishIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_328_494)">
				<path
					d="M0 15.9995C0 17.9566 0.352062 19.8313 0.995186 21.5646L16 22.9559L31.0048 21.5646C31.6479 19.8313 31.9999 17.9566 31.9999 15.9995C31.9999 14.0423 31.6479 12.1676 31.0048 10.4343L16 9.04297L0.995186 10.4343C0.352062 12.1676 0 14.0423 0 15.9995H0Z"
					fill="#FFDA44"
				/>
				<path
					d="M31.0048 10.4338C28.7441 4.34108 22.8794 -0.000976562 16 -0.000976562C9.1206 -0.000976562 3.25592 4.34108 0.995239 10.4338H31.0048Z"
					fill="#D80027"
				/>
				<path
					d="M0.995239 21.5645C3.25592 27.6572 9.1206 31.9992 16 31.9992C22.8794 31.9992 28.7441 27.6572 31.0048 21.5645H0.995239Z"
					fill="#D80027"
				/>
			</g>
			<defs>
				<clipPath id="clip0_328_494">
					<rect width="31.9999" height="31.9999" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
